"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale integrations Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HazmatInformationComment = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.HazmatInformationComment = {
    CANNOT_SHIP_BY_AIR: 'This item cannot be shipped by air.',
    OTHER: 'Please contact Flexport support.',
    REQUIRES_REFRIGERATION: 'This item requires refrigeration.',
    SDS_EXPIRED: 'SDS expired.',
    SPECIAL_HANDLING_PROTECTION: 'This item requires special handling protection.',
    UNSUPPORTED_UN_ID: 'Unsupported UN ID. This item is not an allowable hazmat item.'
};
//# sourceMappingURL=hazmat-information-comment.js.map